<template>
  <div class="industry-targets">
    <div class="app-step-two-tabs-targeting-tabs__descr">
      <p class="industry-targets__title">
        Choose {{ packageItem?.maxFreeIndustryTargets }} industry
        {{ pluralize(packageItem?.maxFreeIndustryTargets, 'target') }}.
      </p>
      <p class="industry-targets__subtitle">
        Additional targets are available at
        {{ formatPrice(packageItem?.extraIndustryTargetPrice) }} each:
      </p>
    </div>

    <targeting-list
      :selected-items="selectedItems"
      :resource-url="API.getIndustryTargetsResource"
      payload-key-name="industryTargets"
    ></targeting-list>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useOrder } from '@core/composables/order/useOrder'
import { pluralize } from '@core/utils/helpers'
import { formatPrice } from '@core/utils/price'
import API from '@core/api'
import TargetingList from '@modules/app-steps/step-two/tabs/targeting/targeting-list/index.vue'

const { order } = useOrder()

const packageItem = computed(() => order?.value?.packagePrice?.package)
const selectedItems = computed(() => order?.value?.industryTargets ?? [])
</script>
